@if (!isDismissed()) {
  <div class="sunset-banner">
    <div class="sunset-banner-content">
      <div class="sunset-banner-left">
        <div class="sunset-banner-icon">
          <lucide-icon [img]="Info" [size]="20" />
        </div>
        <div class="sunset-banner-text">
          <span class="sunset-banner-title">
            This app will be discontinued and replaced with XQworkflow in the coming months.
          </span>
          <span class="sunset-banner-subtitle">
            Read our blog to learn what's changing and what to expect.
          </span>
        </div>
      </div>
      <div class="sunset-banner-actions">
        <a
          class="sunset-banner-btn sunset-banner-btn--primary"
          href="https://xqworkflow.com/blog/xqworkflow-the-next-generation-of-operational-workflow-management"
          target="_blank"
        >
          Read the Blog
        </a>
        <a class="sunset-banner-btn sunset-banner-btn--secondary" href="mailto:mail@terlumina.com">
          Contact Us
        </a>
      </div>
      <button
        class="sunset-banner-dismiss"
        (click)="dismissBanner()"
        aria-label="Dismiss sunset notice"
      >
        <lucide-icon [img]="X" [size]="16" />
      </button>
    </div>
  </div>
}
